/**
 * Manifest of all approved Lumi voice lines that a given lesson may surface.
 *
 * This is derived deterministically from the static coaching/life-event
 * registries — there is no AI generation here. The list is used at lesson
 * load to pre-resolve audio URLs through the cached `lumi-voice` edge
 * function so the speaker button can play instantly.
 */
import {
  getLumiLessonIntro,
  getLumiLessonOutcome,
  getLumiDecideMissCoaching,
  getLumiDecidePassCoaching,
  getLumiLifeEventCoaching,
} from "@/data/lumiLaunchCoaching";
import { betaLifeEvents } from "@/data/launchLifeEvents";

export function getLumiLessonAudioTexts(lessonId: string): string[] {
  const texts: Array<string | undefined> = [
    getLumiLessonIntro(lessonId)?.message,
    getLumiLessonOutcome(lessonId, "success")?.message,
    getLumiLessonOutcome(lessonId, "mistake")?.message,
    getLumiDecidePassCoaching(lessonId).message,
    getLumiDecideMissCoaching(lessonId).message,
  ];

  // Any life events anchored to this lesson — both outcomes.
  for (const ev of betaLifeEvents) {
    if (ev.anchor.kind === "lesson" && ev.anchor.lessonId === lessonId) {
      texts.push(
        getLumiLifeEventCoaching(ev.id, true)?.message,
        getLumiLifeEventCoaching(ev.id, false)?.message,
      );
    }
  }

  return Array.from(new Set(texts.filter((t): t is string => !!t && t.trim().length > 0)));
}